import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-692fb3fd"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  key: 0,
  class: "draw-box"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "result-title"
}, "恭喜抽中", -1));

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "result-hint"
}, "已成功报名，请按时参加", -1));

const _hoisted_4 = {
  key: 1,
  class: "draw-box"
};

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "result-title"
}, "抱歉，未抽中", -1));

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "result-hint"
}, "欢迎关注后续活动", -1));

export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    status: Number // 1 中签 0 未中签

  },
  emits: ['update:show'],

  setup(__props, {
    emit
  }) {
    const handleClose = () => {
      emit('update:show', false);
    };

    return (_ctx, _cache) => {
      const _component_svg_icon = _resolveComponent("svg-icon");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: __props.show,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(show) ? show.value = $event : null),
        title: "参与报名抽签",
        width: "400px",
        "append-to-body": true,
        "before-close": handleClose
      }, {
        default: _withCtx(() => [__props.status ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_svg_icon, {
          icon: "win_icon",
          "class-name": "draw-image"
        }), _hoisted_2, _hoisted_3])) : (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_component_svg_icon, {
          icon: "lose_icon",
          "class-name": "draw-image"
        }), _hoisted_5, _hoisted_6]))]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }

};